<template>
  <div>
    <equipment-edit v-model="equipment" title="Other equipment" :sites="sites"
                    @save="save" :loading="loading" :saving="saving" :dirty.sync="dirty">
      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <v-autocomplete v-model="equipment.equipmentTypeId" outlined dense label="Type" :items="types" item-text="name" item-value="id">
            <template v-slot:prepend-item>
              <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="typeCreate=true">
                <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new type
              </div>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </equipment-edit>

    <equipment-types-quick-create v-model="typeCreate" @create="types.push($event);equipment.equipmentTypeId=$event.id"/>
    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import EquipmentEdit from '@/views/equipment/EquipmentEdit'
import confirmLeave from '@/mixins/confirmLeave'
import EquipmentTypesQuickCreate from '@/views/equipment/other/EquipmentTypesQuickCreate'

export default {
  name: 'EquipmentOtherEdit',
  mixins: [confirmLeave],
  components: {EquipmentEdit,EquipmentTypesQuickCreate},
  props: {
    equipmentId: {type:String, required:false}
  },
  data () {
    return {
      equipment: {name:'',equipmentTypeId:null,active:true,siteId:'',manufacturer:'',modelNumber:'',serialNumber:'',
                  maintenance:{frequency:0,frequencyUnits:'never',nextDate:format(new Date(), 'yyyy-MM-dd'),description:''}},
      types: [{name:'Other',id:null},{divider:true}],
      typeCreate: false,
      loading: false,
      saving: false,
      dirty: false
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(!this.equipmentId);
    }
  },
  async created() {
    this.loading = true;
    this.$lazyListLoad(this.types, 'equipmentTypes2', 'id,name', 100);
    const results = await this.$apiCall(`query EquipmentOtherEdit($id:ID!,$edit:Boolean!) {
                                              otherEquipment(id:$id) @include(if:$edit) {
                                                id,name,active,site{id},pictureURL,equipmentType{id},
                                                manufacturer,modelNumber,serialNumber,
                                                maintenance {frequency,frequencyUnits,nextDate,description}
                                              }
                                            }`,
                                        {edit:this.equipmentId!==undefined,id:this.equipmentId||''});
    this.loading = false;
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    if (this.equipmentId)
      this.equipment = {...results.data.otherEquipment, siteId:results.data.otherEquipment.site.id, site:undefined,
                        equipmentTypeId:results.data.otherEquipment.equipmentType?.id ?? null, equipmentType:undefined};
    else
      this.equipment.siteId = this.sites[0].id;
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    async save() {
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {pictureURL, ...input} = this.equipment;
      const results = await this.$apiCall(`mutation EquipmentOtherEdit($input: OtherEquipmentInput!) {
                                             otherEquipmentCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.equipment.id?'Updated':'Created'} equipment ${this.equipment.name}`});
      }
    }
  }
}
</script>